import React, { useState, useEffect } from 'react';
import { MapPin, Store } from 'lucide-react';
import { adminOutletMapAPI } from '../../utils/api';
import { toast } from '../../hooks/use-toast';
import { Toaster } from '../ui/toaster';

const OutletMapManagement = () => {
  const [mapData, setMapData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadMapData();
  }, []);

  const loadMapData = async () => {
    try {
      setLoading(true);
      const response = await adminOutletMapAPI.getMap();
      setMapData(response.data);
    } catch (error) {
      toast({
        title: "Error",
        description: error.message || "No se pudieron cargar los datos del mapa",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 space-y-6">
      <Toaster />
      <div>
        <h2 className="text-2xl font-bold text-white">Mapa del Outlet</h2>
        <p className="text-[#A2A2A2]">Visualización del mapa con ubicación de tiendas</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-[#A2A2A2]">Cargando...</div>
      ) : !mapData || !mapData.stores || mapData.stores.length === 0 ? (
        <div className="text-center py-12 text-[#A2A2A2]">
          <MapPin className="w-16 h-16 mx-auto mb-4 opacity-50" />
          <p>Pendiente definición de mapa</p>
          <p className="text-sm mt-2">Los datos del mapa se mostrarán aquí cuando estén disponibles</p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Lista de tiendas con posición */}
          <div className="bg-white/5 border border-white/10 rounded-2xl overflow-hidden">
            <div className="p-4 border-b border-white/10">
              <h3 className="text-lg font-semibold text-white">Tiendas en el mapa</h3>
            </div>
            <div className="divide-y divide-white/10">
              {mapData.stores.map((store) => (
                <div key={store.id} className="p-4 hover:bg-white/5 flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <div className="w-12 h-12 bg-white/10 rounded-lg flex items-center justify-center">
                      <Store className="w-6 h-6 text-white" />
                    </div>
                    <div>
                      <div className="text-white font-medium">{store.name}</div>
                      <div className="text-[#A2A2A2] text-sm">{store.category}</div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2 text-[#A2A2A2] text-sm">
                    <MapPin className="w-4 h-4" />
                    <span>X: {store.map_x}, Y: {store.map_y}</span>
                    {store.is_featured && (
                      <span className="ml-2 px-2 py-1 bg-yellow-500/20 text-yellow-400 rounded-full text-xs">
                        Destacada
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Nota sobre implementación futura */}
          <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4">
            <p className="text-blue-400 text-sm">
              <strong>Nota:</strong> Esta es una vista preliminar. El mapa interactivo se implementará en una futura actualización.
              La estructura está preparada para integrar un componente de mapa más complejo.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default OutletMapManagement;

